import api from "../api";

export default {
    destroy(type) {
        return api.delete(`/central/types/${type}`)
    },
}